import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import AutocompleteHeader from "@/components/Search/SearchBar/AutocompleteItem/autocompleteHeader.container";
import { RecentSearchesItem } from "@/components/Search/SearchBar/RecentSearches/recentSearches.item.component";
import {
    clearRecentSearches,
    removeRecentSearchesItem
} from "@/components/Search/SearchBar/RecentSearches/recentSearches.source";
import { BaseTemplateProps } from "@/components/Search/SearchBar/ResultsPanel/resultsPanel.templates";
import { RecentSearchesSourceType } from "@/components/Search/SearchBar/searchBar.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type RecentSearchesTemplateProps = BaseTemplateProps<RecentSearchesSourceType>;

const RecentSearchesTemplate = ({
    items,
    autocompleteState,
    autocompleteActions
}: RecentSearchesTemplateProps) => {
    const { t } = useGranite();
    if (items.length === 0) return null;

    const handleOnRemoveRecentSearchItem = (label: string) => {
        removeRecentSearchesItem(label);
        autocompleteActions?.refresh();
    };

    const handleOnClearAllRecentSearchItem = () => {
        clearRecentSearches();
        autocompleteActions?.refresh();
    };

    return (
        <div>
            <AutocompleteHeader
                headerTitle={t("searchBox.panel.recentSearches.header.title")}
            >
                <Button
                    type={"button"}
                    color={"link"}
                    className={cn("tw:py-2 tw:px-0 tw:text-primary")}
                    onClick={handleOnClearAllRecentSearchItem}
                >
                    {t("searchBox.panel.recentSearches.footer.button.clearAll")}
                </Button>
            </AutocompleteHeader>
            <ul className={cn("tw:mb-0")}>
                {items.map((item) => (
                    <li key={item.label}>
                        <RecentSearchesItem
                            item={item}
                            onRemoveRecentSearchItem={
                                handleOnRemoveRecentSearchItem
                            }
                            autocompleteState={autocompleteState}
                            autocompleteActions={autocompleteActions}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default RecentSearchesTemplate;
